import { css } from "@/../styled-system/css";

import AvatarSkeleton from "./AvatarSkeleton";
import Skeleton from "../ui/Skeleton";

function ProfileHeaderSkeleton() {
  return (
    <>
      <AvatarSkeleton size="md" />
      <div className={css({ width: "100%", minWidth: "0" })}>
        <Skeleton css={{ width: "100%", height: "1.125rem", mb: "0.5" }} />
        <Skeleton css={{ width: "100%", height: "1.125rem" }} />
      </div>
    </>
  );
}

export default ProfileHeaderSkeleton;
